import { MasterDataTable } from "@/components/MasterDataTable";
import { useAdminTemplateFormatTypes, useTemplateFormatTypeAdmin } from "@/hooks/useMasterData";

const TemplateFormatTypes = () => {
  const { data: formatTypes = [], isLoading } = useAdminTemplateFormatTypes();
  const admin = useTemplateFormatTypeAdmin();

  return (
    <MasterDataTable
      items={formatTypes.map((i) => ({ id: String(i.id), label: i.name, is_active: i.is_active }))}
      valueLabel="Name"
      isLoading={isLoading}
      onCreate={(name) => admin.create.mutateAsync(name)}
      onUpdate={(id, data) => admin.update.mutateAsync({ id, data })}
      onDelete={(id) => admin.remove.mutateAsync(id)}
    />
  );
};

export default TemplateFormatTypes;
